import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface ServicePointNameProps {
  name: string;
  className?: string;
  mode?: "truncate" | "wrap";
}

export default function ServicePointName({
  name,
  className,
  mode = "wrap",
}: ServicePointNameProps) {
  if (mode === "truncate") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className={cn("block min-w-0 truncate", className)}>
              {name}
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">{name}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <span className={cn("block break-words whitespace-normal", className)}>
      {name}
    </span>
  );
}
